export class Condition {
    name: string;
    field_key: string;
    op: string;
    length: number;
    value: any;
    error_msg: string;
    dependencies: ConditionDependencies;
    result: boolean;
    data_type: string;
    error: any;
    eval_data_type: string;
}

export class ConditionDependencies {
    name: string;
    conditions: string[];
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/condition.model.ts